/**
 * Slip-related models
 */

/**
 * Slip DTO (Response)
 */
export interface SlipDto {
  id: string;
  name: string;
  type?: string | null;
  length?: number | null;
  width?: number | null;
  depth?: number | null;
  maxVesselLength?: number | null;
  status?: string | null;
  currentLeaseId?: string | null;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

